import {STEPPER} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';
import ProductFinal from '../../../../../assets/pictos/empty-picto/empty_products.png';
import Mapping from '../components/Mapping';

const ImportProducts =  {
    titleForm: 'products.list.importation.title',
    subTitleForm: 'products.list.importation.subtitle',
    langSelect: false,
    drawerType: 'drawer',
    noForm: true,
    component: Button,
    formConfig: {
        type: STEPPER,
        finalStep: {
            picto: ProductFinal,
            title: 'Bientôt prêt !',
            subtitle: 'Votre fichier est prêt à être importé :)',
            textButton: 'Importer le fichier'
        },
        children: [
            {
                labelName: 'products.list.importation.choosefield',
                isOptionnal: false,
                optionsInputs: []
            },
            {
                labelName: 'Mapping',
                isOptionnal: false,
                component: Mapping,
                optionsInputs: []
            }
        ]
    }
};

export default ImportProducts;